// extracted by mini-css-extract-plugin
export default {"wrapper":"Content_wrapper__gF8ne","content":"Content_content__nC8pN","card":"Content_card__ijXFy","empty":"Content_empty__2Eu+G","title":"Content_title__S2NOz"};